import styled from 'styled-components'
import tw from 'twin.macro'

interface Props {
  isValid?: boolean
}

const StBaseValidLabel = styled.div<Props>`
  ${tw`flex items-center h-3 text-base text-red-500`}
  ${({ isValid }) => isValid && tw`text-blue-600`}
`

export default StBaseValidLabel
